const syncFns: { [key: string]: any } = {};

export function startSyncing(fromSelector: string, toSelector: string) {

	const key = `from-${fromSelector}-to-${toSelector}`;
	const $from = $(fromSelector);
	const $to = $(toSelector);

	if (syncFns[key])
		$from.off('keyup', syncFns[key]);

	let lastFromText = $from.val() as string;

	$(fromSelector).keyup(syncFns[key] = function () {
		const newText = $from.val() as string;
		const toText = $to.val() as string;

		// Evitamos sobrepasar la longitud máxima del input
		if ($to.attr('maxLength') && newText.length > parseInt($to.attr('maxLength')!, 10))
			return;

		if (lastFromText.substring(0, lastFromText.length) === toText) {
			$to.val(newText);
			// hack para que funcione en React 16. https://github.com/facebook/react/issues/11488
			const event = new Event('input', { bubbles: true }) as any;
			event.simulated = true;

			const lastValue = $to[0].nodeValue;
			const tracker = ($to[0] as any)._valueTracker;
			if (tracker) {
				tracker.setValue(lastValue);
			}
			$to[0].dispatchEvent(event);
		}
		lastFromText = newText;
	});
}

export function stopSyncing(fromSelector: string, toSelector: string) {
	const key = `from-${fromSelector}-to-${toSelector}`;

	if (syncFns[key])
		$(fromSelector).off('keyup', syncFns[key]);

	syncFns[key] = undefined;
}
